import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';
const baseUrl = new APISettings().getApiURL();

class TaskBoardColumnApi<TaskBoardColumns> extends BaseAPI {
  // constructor() {}

  public getTaskBoardColumns: () => Promise<TaskBoardColumns> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/taskBoardColumns/`)).data.output;
  };
}

export const taskBoardColumnAPI = new TaskBoardColumnApi();
